import { Provider } from '@angular/core'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'
import { AUTH_STORE } from '@yoshu-lib/core/tokens/auth-store.token'

export const provideTrevesAuthStore = (): Provider => ({
  provide: AUTH_STORE,
  useExisting: AuthStore
})
